const Forms = [
    {
        'formId' : 'P-01',
        'formTitle': 'Tambahkan Laporan Pemasukkan',
        'question': {
            'askId': 'ID Tutor',
            'askName': 'Nama Lengkap Tutor',
            'askSubject': 'Total Subjek (Mata Pelajaran)',
            'askSession': 'Total Sesi',
            'askTotal': 'Jumlah (Rp)' 
        } 
    },
    {
        'formId' : 'P-02',
        'formTitle': 'Tambahkan Laporan Pengeluaran',
        'question': {
            'askId': 'ID Admin',
            'askName': 'Nama Lengkap Admin',
            'askPurpose': 'Keperluan Penggunaan',
            'askTotal': 'Jumlah (Rp)' 
        } 
    }
];

const getFormById = (formId) => {
    return (formId === undefined) ? Forms[0] : Forms.find(x => x.formId === formId);
};
  
export {
    Forms,
    getFormById
};